import { configureStore } from "@reduxjs/toolkit";

import cardReducer from "../store/slices/cardSlice";
import categoriesReducer from "../store/slices/categoriesSlice";
import daysReducer from "../store/slices/daysSlice";
import exactPostReducer from "../store/slices/exactPostSlice";
import postCategoriesReducer from "../store/slices/postCategoriesSlice";
import postOrderReducer from "../store/slices/postOrderSlice";
import postsReducer from "../store/slices/postsSlice";
import productCategoriesReducer from "../store/slices/productCategoriesSlice";
import productsReducer from "../store/slices/productsSlice";
import reviewsByCategoryReducer from "../store/slices/reviewsByCategorySlice";
import reviewsReducer from "../store/slices/reviewsSlice";
import timeReducer from "../store/slices/timeSlice";

const store = configureStore({
  reducer: {
    posts: postsReducer,
    postCategories: postCategoriesReducer,
    exactPost: exactPostReducer,
    reviews: reviewsReducer,
    reviewsByCategory: reviewsByCategoryReducer,
    categories: categoriesReducer,
    days: daysReducer,
    postOrder: postOrderReducer,
    time: timeReducer,
    card: cardReducer,
    productCategories: productCategoriesReducer,
    products: productsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
